import $ from 'jquery';

function initMaterialDisplay() {
	const material = $('.material-display');
	const ua = window.navigator.userAgent;
	const trident = ua.indexOf('Trident/');

	if( trident > 0) {
		$('body').addClass("ie-11");
	}

	if( (material).is('#material') ) {
		$("html, body").animate({ scrollTop: material.offset().top }, "slow");
	}

	if( $('.material-filter').is('#material-filter-dropdown') ) {
		$("html, body").animate({ scrollTop: material.offset().top }, "slow");
	}

	$('select#material_type').change(function() {
		$('#material-filter').submit();
	});

	$('.material-filter__list__item a').on('click', function() {
		var e = $(this).data('material-id');
		$('input#material_id').val(e),$('#material-filter').submit();
	});

}
document.addEventListener('DOMContentLoaded', initMaterialDisplay);

